module.exports = __webpack_public_path__ + "static/media/transfer.38ecfe7f.svg";